import React, { useState, useContext, useEffect } from 'react';
import { Button, Form, FormGroup, Col, Row, Label, Input, InputGroup, InputGroupAddon, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link, Route, useParams } from 'react-router-dom';
import Alert from 'react-s-alert';
import moment from 'moment';
import Joyride, { STATUS } from 'react-joyride';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// import services
import ProviderService from '../../services/ProviderService';
import AuthService from '../../services/AuthService';
import GeneralService from '../../services/GeneralService';

// local imports
import ProviderNavbar from './ProviderNavbar';
import Footer from '../general/Footer';
import ErrorBoundary from '../general/ErrorBoundary';

const ViewProviderProfile = props => {

    // contexts
    const { theme, fontSize, colors, fontFamily, fontWeight } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone } = useContext(AuthContext);

    // states
    const [provider, setProvider] = useState({
        providerUniqueId: null,
        description: ''
    })
    const [showMoreDescription, setShowMoreDescription] = useState({ visible: false, status: false, maxWords: 70 });
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>View your profile details from here!</h2>,
                placement: 'center',
                target: '#providerProfileDiv',
            },
            {
                content: <div className="tooltipDiv">View public page of your profile by pressing here!</div>,
                placement: 'left',
                target: '#viewBtn',
            },
            {
                content: <div className="tooltipDiv">Edit your profile details by pressing here!</div>,
                placement: 'left',
                target: '#editBtn',
            }
        ]
    });
    let helpers = null;

    // variables
    const { providerUniqueId } = useParams();

    // useEffects
    useEffect(() => {
        // load provider data
        try {
            ProviderService.getProviderProfile()
                .then(data => {
                    // console.log(data)
                    setProvider({
                        title: data.provider.title,
                        firstName: data.provider.firstName,
                        lastName: data.provider.lastName,
                        email: data.provider.email,
                        gender: data.provider.gender,
                        phone: data.provider.phone,
                        city: data.provider.city,
                        state: data.provider.state,
                        country: data.provider.country,
                        pincode: data.provider.pincode,
                        specialities: data.provider.specialities ? data.provider.specialities.join(', ') : [],
                        languages: data.provider.languages ? data.provider.languages.join(', ') : [],
                        degrees: data.provider.degrees ? data.provider.degrees.join(', ') : [],
                        description: data.provider.description,
                        profileImage: data.provider.profileImage,
                        availableTimes: data.provider.availableTimes ? data.provider.availableTimes : [],
                        providerUniqueId: data.provider.providerUniqueId,
                        providerIDSelected: data.provider.providerIDSelected,
                        updatedAt: data.provider.updatedAt,
                        socialLinkFacebook: data.provider.socialLinkFacebook,
                        socialLinkInstagram: data.provider.socialLinkInstagram,
                        socialLinkTwitter: data.provider.socialLinkTwitter,
                        socialLinkYoutube: data.provider.socialLinkYoutube,
                        socialLinkQuora: data.provider.socialLinkQuora,
                        socialLinkMedium: data.provider.socialLinkMedium,
                        socialLinkLinkedin: data.provider.socialLinkLinkedin
                    });
                }).catch(err => {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    GeneralService.logError('at Provider ViewProviderProfile useEffect', 'Error in try catch block', err.stack);
                })

        }
        catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderPublicPage useEffect', 'Error in try catch block', err.stack);
        }
    }, [])

    useEffect(() => {
        handleDescriptionChange();
    }, [provider.description]);

    //utility function
    const createMarkup = (html) => {
        return { __html: html };
    }

    const truncateString = (str, no_words) => {
        return str.split(" ").splice(0, no_words).join(" ") + ".....";
    }

    // handle functions
    const handleDescriptionChange = () => {
        // let element = document.getElementById("providerDescription");
        // element.style["overflow"] = "hidden";
        // element.style["height"] = `${showMoreDescription.maxHeight}px`;
        // if (element.scrollHeight > showMoreDescription.maxHeight) {
        //     setShowMoreDescription({ ...showMoreDescription, visible: true });
        // }
        if (provider.description.split(" ").length > showMoreDescription.maxWords) {
            setShowMoreDescription({ ...showMoreDescription, visible: true });
        }
    }

    const handleShowMoreClick = () => {
        let element = document.getElementById("providerDescription");
        // console.log("window.screenX", window.screenX, "window.screenY", window.scrollY, "height", element.scrollHeight, "max", showMoreDescription.maxHeight);
        if (showMoreDescription.status) {
            // setShowMoreDescription({ ...showMoreDescription, status: false });
            // element.style["overflow"] = "hidden";
            // element.style["height"] = `${showMoreDescription.maxHeight}px`;
            document.getElementById("providerProfileAboutMeLabel").scrollIntoView();
            window.scrollBy(0, -50);
        } else {
            // setShowMoreDescription({ ...showMoreDescription, status: true });
            // element.style["overflow"] = "auto";
            // element.style["height"] = "auto";
        }
        setShowMoreDescription({ ...showMoreDescription, status: !showMoreDescription.status })
    }

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.guideTakenFor.includes("ViewProviderProfile")) {
                AuthService.markVisited("ViewProviderProfile");
                setUser({ ...user, guideTakenFor: [...user.guideTakenFor, "ViewProviderProfile"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        <div id="providerProfileDiv">
            <ErrorBoundary errorAt="At Provider ViewProviderProfile Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>

            <ProviderNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />

            <div style={{ overflowWrap: "anywhere" }}>
                <div className="mx-3 mt-3 row">
                    <h1 id="ViewProviderProfileText" style={theme.headingBold}>Profile</h1>

                    <a id="viewBtn" className="ml-auto" href={`/counsellors/${provider.providerUniqueId}`}>
                        <span style={{ color: colors.primary }} id="ProviderProfilePublicPage">
                            <i id="ViewProviderProfilePublicPageText" className="fas fa-eye"></i> Public Page
                        </span>
                    </a>

                    <Link id="editBtn" to={"/counsellor/profile/edit"}>
                        <span className="ml-3" style={{ color: colors.primary }} id="ProviderProfileEditText">
                            <i id="ViewProviderProfileEditText" className="fas fa-edit"></i> Edit
                        </span>
                    </Link>
                </div>

                <hr className="mx-3" style={{ borderWidth: "2px" }} />

                <div className="mt-5 row p-3">
                    <div style={{ border: "5px solid", borderRadius: "10px", borderColor: colors.primary, background: colors.primary, maxWidth: "0px", maxHeight: "100%" }}></div>
                    <div className="col-md-3 col-sm-3 col-11 py-3">
                        {/* <div style={{position: 'absolute', left: "5%", border: "5px solid", borderRadius: "10px", borderColor: colors.primary, maxWidth: "0px", minHeight: "100%"}}></div> */}
                        <div className="mx-auto text-center" style={{ width: "120px", height: "120px" }}>
                            <img id="providerProfileImg" className="m-auto w-100 h-100" src={provider.profileImage} alt="Counsellor" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                        </div>
                    </div>

                    <div className="col-md-8 col-sm-8 col-11">
                        <h1 style={{ fontFamily: fontFamily.primary, fontSize: "2.5rem", fontWeight: fontWeight.medium }}>{provider.title} {provider.firstName} {provider.lastName}</h1>
                        <h2 style={{ fontFamily: fontFamily.primary, fontSize: "1.5rem", fontWeight: fontWeight.regular }}>Psychologist</h2>

                        <p className="mt-4" style={theme.paragraph}>
                            <i className="fas fa-map-marker-alt"></i> <span>{provider.city}, {provider.state} - {provider.country}</span>
                        </p>
                    </div>
                </div>

                <p className="float-right" ><span style={theme.paragraphHeading}>Last Updated - </span><span style={theme.paragraph}>{moment(provider.updatedAt).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format('MMM DD, YYYY')}</span></p>

                <hr className="mt-5" />

                <div className="my-3 row p-3">

                    <div className="col-md-3 col-sm-3 col-12">
                        <p id="providerProfileEmailLabel" className="m-0" style={theme.paragraphHeading}>Email</p>
                        <p className="m-0" style={theme.paragraph}>{provider.email}</p>

                        <br />

                        <p id="providerProfileGenderLabel" className="m-0" style={theme.paragraphHeading}>Gender</p>
                        <p className="m-0" style={theme.paragraph}>{provider.gender}</p>

                        <br />

                        <p id="providerProfileLanLabel" className="m-0" style={theme.paragraphHeading}>Languages</p>
                        <p className="m-0" style={theme.paragraph}>{provider.languages}</p>

                        <br />

                        <p id="providerProfileDegreeLabel" className="m-0" style={theme.paragraphHeading}>Degree / License</p>
                        <p className="m-0" style={theme.paragraph}>{provider.degrees}</p>

                        <br />

                        <p id="providerProfileSpecLabel" className="m-0" style={theme.paragraphHeading}>Specialities</p>
                        <p className="m-0" style={theme.paragraph}>{provider.specialities}</p>

                        <br />

                        <p id="providerProfileContactLabel" className="m-0" style={theme.paragraphHeading}>Contact Number</p>
                        <p className="m-0" style={theme.paragraph}>{provider.phone}</p>

                        <br />

                    </div>

                    <div className="col-md-9 col-sm-9 col-12">
                        <h3 id="providerProfileAboutMeLabel" className="mb-3" style={{ fontFamily: fontFamily.primary, fontSize: "1.5rem", fontWeight: fontWeight.medium }}>About Me</h3>
                        <div id="providerDescription" style={{ fontFamily: fontFamily.primary, fontSize: "1.1rem", textAlign: "justify" }} dangerouslySetInnerHTML={createMarkup(showMoreDescription.status ? provider.description : truncateString(provider.description, showMoreDescription.maxWords))}></div>
                        {showMoreDescription.visible ? <div style={{ cursor: "pointer", textAlign: "end" }} onClick={() => handleShowMoreClick()}><b>{showMoreDescription.status ? "Read less" : "Read more"}</b></div> : null}

                        <br />
                        <br />

                        <h3 id="ViewProviderProfilePublicPageLink" className="mb-3" style={{ fontFamily: fontFamily.primary, fontSize: "1.5rem", fontWeight: fontWeight.medium }}>Public Page Link</h3>
                        {
                            provider.providerIDSelected
                                ? <p style={{ fontFamily: fontFamily.primary, fontSize: "1.1rem" }}>https://www.umangwellness.com/counsellors/<span style={{ fontWeight: 600 }}>{provider.providerUniqueId}</span></p>
                                : <span style={{ color: "#FFC107" }}><i className="fas fa-exclamation-circle"></i> Counsellor ID yet to setup, goto edit profile to setup it.</span>
                        }

                        <br />
                        <br />

                        <h3 id="ViewProviderProfileSocialLinks" className="mb-3" style={{ fontFamily: fontFamily.primary, fontSize: "1.5rem", fontWeight: fontWeight.medium }}>Social Links</h3>

                        {
                            provider.socialLinkFacebook
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Facebook</span> - {provider.socialLinkFacebook}
                                    <a className='ml-2' href={`https://${provider.socialLinkFacebook}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null

                        }

                        {
                            provider.socialLinkTwitter
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Twitter</span> - {provider.socialLinkTwitter}
                                    <a className='ml-2' href={`https://${provider.socialLinkTwitter}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkInstagram
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Instagram</span> - {provider.socialLinkInstagram}
                                    <a className='ml-2' href={`https://${provider.socialLinkInstagram}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkYoutube
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Youtube</span> - {provider.socialLinkYoutube}
                                    <a className='ml-2' href={`https://${provider.socialLinkYoutube}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkQuora
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Quora</span> - {provider.socialLinkQuora}
                                    <a className='ml-2' href={`https://${provider.socialLinkQuora}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkMedium
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Medium</span> - {provider.socialLinkMedium}
                                    <a className='ml-2' href={`https://${provider.socialLinkMedium}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkLinkedin
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>LinkedIn</span> - {provider.socialLinkLinkedin}
                                    <a className='ml-2' href={`https://${provider.socialLinkLinkedin}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }


                    </div>


                </div>
            </div>
            <Footer />

        </div>
    )
}

export default ViewProviderProfile;